import { Breakpoint, useRelodeAppUI } from "@relode/core";
import * as React from "react";
import styled from "styled-components";

import {
    MarketResearchMarketingDesktop,
} from "./marketResearchMarketingDesktop";
import { MarketResearchMarketingMobile } from "./marketResearchMarketingMobile";

export type MarketResearchMarketingProps = {
    jobManagerName: string;
    jobManagerPhoneNumber: string;
    jobManagerEmail: string;
};

export const MarketResearchMarketing = (
    props: MarketResearchMarketingProps
) => {
    const { ui } = useRelodeAppUI();
    React.useEffect(() => {
        ui.actions.setPageTitle("market research");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Breakpoint desktop>
                <MarketingSection>
                    <MarketResearchMarketingDesktop {...props} />
                </MarketingSection>
            </Breakpoint>
            <Breakpoint mobile>
                <MarketingSection>
                    <MarketResearchMarketingMobile {...props} />
                </MarketingSection>
            </Breakpoint>
        </>
    );
};

const MarketingSection = styled.div`
    overflow: auto;
`;
